import { createStorage } from '@aviata/storage';
import type { Tourflow } from '@aviata/platform-types';

import type { SelectedDates } from '@entities/dates-picker';
import { devMetrics } from '@entities/dev-metrics';
import {
  LEGACY_LAST_SEARCH_STORAGE_KEY,
  SEARCH_HISTORY_STORAGE_KEY,
} from './config';
import { isDateExpired, isSearchHistory } from './lib';

export type LastSearch = {
  townsTo: Tourflow.TownTo[] | null;
  countryTo: Tourflow.CountryTo;
  townFrom: Tourflow.TownFrom;
  depDate: SelectedDates;
  arrDate: SelectedDates;
  adt: number;
  childrenAge: number[];
};

function setSearchHistory(lastSearch: LastSearch[]) {
  const storage = createStorage(localStorage);
  storage.stringify(SEARCH_HISTORY_STORAGE_KEY, lastSearch);
}

function getSearchHistory(): LastSearch[] | null {
  const storage = createStorage(localStorage);

  // TODO: Remove this code after 2 months, since most of the users will be using the new key anyway
  if (storage.get(LEGACY_LAST_SEARCH_STORAGE_KEY)) {
    devMetrics.increment('dev.legacy_last_search_cleared');
    storage.remove(LEGACY_LAST_SEARCH_STORAGE_KEY);
  }

  const lastSearch = storage.parse(SEARCH_HISTORY_STORAGE_KEY) as unknown[];

  return isSearchHistory(lastSearch) ? lastSearch : null;
}

function getValidSearchHistory() {
  const searchHistory = getSearchHistory();

  if (!searchHistory) {
    return null;
  }

  return searchHistory.map(item => {
    if (isDateExpired(item.depDate)) {
      return {
        ...item,
        depDate: {
          from: '',
          to: '',
        },
        arrDate: {
          from: '',
          to: '',
        },
      };
    }

    return item;
  });
}

/*
 * @note This is a setup for proper search history lib, as of 11.12.2024,
 * we just save one search and display it in search form
 *
 * TODO: Implement proper search history feature
 */
export const lastSearchLib = {
  get: getValidSearchHistory,
  set: setSearchHistory,
};
